// extracted by mini-css-extract-plugin
module.exports = {"steps":"SavedSearchesIntroStepList_steps__LvmGe","magnifyingGlass":"SavedSearchesIntroStepList_magnifyingGlass___i0dN"};